<p-toast position="top-right"></p-toast>
<div class="h-screen overflow-hidden print:h-auto print:overflow-visible flex relative lg:static bg-surface-50 dark:bg-surface-950">
  <div class="w-[280px] bg-surface-900 h-full hidden lg:flex flex-col shrink-0 absolute lg:static left-0 top-0 z-10 border-r border-surface-800 select-none">
    <div class="flex flex-col h-full">
      <div class="p-4 flex items-center gap-4">
        <img src="assets/images/greezmate-logo.png" alt="Greezmate" class="h-10 w-auto">
      </div>
      <app-tenant-badge></app-tenant-badge>
      <app-sidebar></app-sidebar>
      <app-user-action-menu></app-user-action-menu>
    </div>
  </div>
  <div class="flex-1 h-full overflow-y-auto print:h-auto print:overflow-visible flex flex-col">
    <app-offline-banner></app-offline-banner>
    <app-billing-banner></app-billing-banner>
    <div class="p-4 flex flex-col flex-auto">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-help-button></app-help-button>
</div>
